import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "form", "allButton", "counter"]
  static values = { 
    baseUrl: String,
    currentParams: Object
  }

  connect() {
    this.updateCounter()
    this.updateAllButtonState()
  }

  toggle(event) {
    const checkbox = event.target
    const isChecked = checkbox.checked
    
    // Update visual state immediately for better UX
    this.updateCheckboxVisualState(checkbox, isChecked)
    
    // Update the checkbox state
    this.updateFormState()
    this.updateCounter()
    this.updateAllButtonState()
    
    // Submit the form to update the results
    this.submitForm()
  }

  clearAll() {
    // Uncheck all checkboxes
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })
    
    this.updateFormState()
    this.updateCounter()
    this.updateAllButtonState()
    this.submitForm()
  }

  updateFormState() {
    // Remove any existing hidden tag inputs
    const existingInputs = this.formTarget.querySelectorAll('input[name="tags[]"]')
    existingInputs.forEach(input => input.remove())
    
    // Add hidden inputs for checked tags
    this.checkboxTargets.forEach(checkbox => {
      if (checkbox.checked) {
        const hiddenInput = document.createElement('input')
        hiddenInput.type = 'hidden'
        hiddenInput.name = 'tags[]'
        hiddenInput.value = checkbox.value
        this.formTarget.appendChild(hiddenInput)
      }
    })
  }

  updateCounter() {
    if (this.hasCounterTarget) {
      const selectedCount = this.selectedTags.length
      if (selectedCount === 0) {
        this.counterTarget.textContent = "Filter by tags:"
      } else {
        this.counterTarget.textContent = `Filter by tags (${selectedCount} selected):`
      }
    }
  }

  updateAllButtonState() {
    if (this.hasAllButtonTarget) {
      const hasSelectedTags = this.selectedTags.length > 0
      this.allButtonTarget.classList.toggle('contacts__tag-shortcut--active', !hasSelectedTags)
    }
  }

  submitForm() {
    // Use Turbo to submit the form without full page reload
    this.formTarget.requestSubmit()
  }

  updateCheckboxVisualState(checkbox, isChecked) {
    const label = checkbox.nextElementSibling
    if (label) {
      label.classList.toggle('contacts__tag-shortcut--active', isChecked)
    }
  }

  get selectedTags() {
    return this.checkboxTargets.filter(checkbox => checkbox.checked).map(checkbox => checkbox.value)
  }
}